import React from 'react'
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";

import {showToastMessage} from "../../modules/toast";
import CreateSchedule from '../schedule/createSchedule';
import {showAlertMessageWithRedirect} from "../../modules/alert";


class EditSchedule extends React.Component {
    state = {
        expectedSchedule: []
    };

    componentDidMount(){
        if(this.props.userInfo.isSignedIn){
            this.setScheduleData(this.props.location.state);
        }
    }

    componentWillReceiveProps(nextProps) {
        if(!this.props.userInfo.isSignedIn && nextProps.userInfo.isSignedIn){
            this.setScheduleData(nextProps.location.state);
        }
    }

    setScheduleData = (state) => {
        if(state && state.data){
            let expectedSchedule = [];
            const data = state.data;
            for(let i = 0; i < data.scheduleOrder.length; i ++){
                expectedSchedule.push(data.schedule[data.scheduleOrder[i]]);
            }

            this.setState({expectedSchedule: expectedSchedule});
            this.props.showToastMessage(data.title + " 일정을 수정합니다.");
        }else{
            this.props.showAlertMessageWithRedirect("일정 정보에 문제가 있습니다.", "/home");
        }
    };

    render() {
        return (
            <div>
                <CreateSchedule edit={true} mine={true} expectedSchedule={this.state.expectedSchedule} docData={this.props.location.state.data}/>
            </div>
        )
    }
}

const mapStateToProps = ({ user }) => ({
    userInfo: user.userInfo
});

const mapDispatchToProps = dispatch => ({
    showToastMessage: message => dispatch(showToastMessage(message)),
    showAlertMessageWithRedirect: (message, url) => dispatch(showAlertMessageWithRedirect(message, url)),
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(EditSchedule))

